import { useRef } from 'react';
import { Box, TableCell, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getCurrentData, getUploadingFile, isLoading } from 'state/reducers/content.reducers';
import { uploadFile } from 'services/content.service';
import { ButtonComponent } from 'components/ButtonComponent';

interface IProps {
	item: any;
}

export const FileTableCell = ({ item }: IProps) => {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const uploadingFile = useAppSelector(getUploadingFile);
	const hiddenFileInput = useRef<any>(null);
	const currentData = useAppSelector(getCurrentData);
	const currentItem = currentData.filter((element: any) => element.id === item.id)[0];
	const loading = useAppSelector(isLoading);

	const handleChange = (event: any) => {
		const file: File = event.target.files![0];
		const data = { file, itemId: currentItem.id };
		dispatch(uploadFile(data));
	};

	return (
		<TableCell sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
			<ButtonComponent
				disabled={loading}
				handleClick={() => hiddenFileInput.current.click()}
				text={uploadingFile ? t('button.please_hold') : t('button.upload_file')}
				icon={<img src={'/icons/upload.svg'} />}
			/>
			<input type="file" accept=".pdf" ref={hiddenFileInput} onChange={handleChange} hidden />
			{currentItem?.image?.originalFileName && <p>{decodeURIComponent(currentItem.image.originalFileName)}</p>}
		</TableCell>
	);
};
